import React from 'react'
import {
  Button,
  Form,
  // Modal
} from 'antd'
// import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

// import { filesize } from 'filesize'
// import { NumericFormat } from 'react-number-format'

import Ngql from 'gql/ninegql'
import { i18Key } from 'utils'

import { getConfig } from 'env'

import { getInitialAvatarSrc, timeFormat } from 'utils/ui'

import avatarDefaultPNG from 'assets/images/avatar_default.png'

import { customAllowedDomain } from '../etc'

// const accountField = {
//   id: true,
//   nid: true,
//   createdAt: true,
//   updatedAt: true,
//   email: true,
//   username: true,
//   subscriptionUpdated: true,
// }

// const userAccountField = {
//   id: true,
//   nid: true,
//   createdAt: true,
//   updatedAt: true,
//   userId: true,
//   accountId: true,
//   active: true,
//   primary: true,
//   account: Ngql.Node(accountField),
// }

const UserNodeField = {
  id: true,
  nid: true,
  // admin: true,
  createdAt: true,
  updatedAt: true,
  email: true,
  displayName: true,
  avatarUrl: true,
  // userAccount: Ngql.NodeConnection(Ngql.Node(userAccountField), {
  //   userAccountFilters: Ngql.Var('filters', 'UserAccountFilter'),
  // }),
}

const UserNode = Ngql.Node(UserNodeField)

const workspaceAllowedDomainField = {
  id: true,
  nid: true,
  allowedDomain: Ngql.Field(true, null, {
    mode: 'all',
    labelKey: i18Key('workspace.field.allowedDomain'),
    type: 'url',
    config: {
      rules: [
        {
          required: true,
          messageKey: i18Key('workspace.validation.allowedDomain.empty'),
        },
        {
          validatorFunc: (t) => {
            return (rule, value) => {
              // console.log('validator : ', rule, value)

              if (
                value != null &&
                value.length > 0 &&
                /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/.test(
                  value,
                ) === false
              ) {
                return Promise.reject(t('workspace.validation.allowedDomain.domain'))
              }

              return Promise.resolve()
            }
          },
        },
        // {
        //   type: "url",
        //   message: "This field must be a valid url."
        // }
      ],
    },
  }),
}

const AppConfigNodeField = {
  id: true,
  nid: true,
  name: true,
  config: true,
  createdAt: true,
  updatedAt: true,
}

const AppConfigNode = Ngql.Node(AppConfigNodeField)

const WorkspaceNodeField = {
  id: true,
  nid: true,
  iconUrl: Ngql.Field(true, null, {
    mode: 'readonly',
    labelKey: i18Key('workspace.field.icon'),
    type: 'custom',
    createDetailElem: (info, reactObj, val, NineGQLUI, values) => {
      console.log('custom - ', info, reactObj, val, NineGQLUI, values)
      if (values != null) {
        const { name, iconUrl } = values

        let url = iconUrl
        if (url == null) {
          url = getInitialAvatarSrc(name)
        }

        return (
          <div className={classNames('user-icon')}>
            <img src={url} alt={name} />
          </div>
        )
      }
      return (
        <div className={classNames('user-avatar')}>
          <img src={avatarDefaultPNG} alt="default" />
        </div>
      )
    },
  }),
  name: Ngql.Field(true, null, {
    mode: 'all',
    labelKey: i18Key('workspace.field.name'),
    type: 'text',
    config: {
      rules: [
        {
          required: true,
          messageKey: i18Key('workspace.validation.name.empty'),
        },
      ],
    },
  }),
  contact: Ngql.Field(true, null, {
    mode: 'all',
    labelKey: i18Key('workspace.field.contact'),
    type: 'text',
    // config: {
    //   rules: [
    //     {
    //       required: false,
    //       messageKey: i18Key('workspace.validation.contact.empty'),
    //     },
    //   ],
    // },
  }),
  note: Ngql.Field(true, null, {
    mode: 'hidden',
    labelKey: i18Key('workspace.field.note'),
    type: 'formattedtext',
    // config: {
    //   rules: [
    //     {
    //       required: false,
    //       messageKey: i18Key('workspace.validation.contact.empty'),
    //     },
    //   ],
    // },
  }),
  // maxMembers: Ngql.Field(true, null, {
  //   // mode: 'all',
  //   modeFunc: () => {
  //     const { maxMemberEditable } = getConfig('workspace')
  //     if (maxMemberEditable === true) {
  //       return 'all'
  //     }
  //     return 'read'
  //   },
  //   labelKey: i18Key('workspace.field.maxMembers'),
  //   type: 'number',
  //   default: 10,
  //   config: {
  //     rules: [
  //       // {
  //       //   required: true,
  //       //   messageKey: i18Key('workspace.validation.maxMembers.empty'),
  //       // },
  //       {
  //         type: 'number',
  //         min: 1,
  //       },
  //     ],
  //   },
  // }),
  // status: Ngql.Field(true, null, {
  //   // mode: 'all',
  //   modeFunc: () => {
  //     const { statusEditable } = getConfig('workspace')
  //     if (statusEditable === true) {
  //       return 'all'
  //     }
  //     return 'read'
  //   },
  //   labelKey: i18Key('workspace.field.status'),
  //   type: 'select-number',
  //   valueKeys: {
  //     0: i18Key('workspace.value.closed'),
  //     1: i18Key('workspace.value.active'),
  //     2: i18Key('workspace.value.evaluation'),
  //   },
  //   inputAttrs: (info, reactObj, val, values) => {
  //     console.log('inputAttrs - ', info, reactObj, val, values)
  //     return {
  //       onChange: (value, options) => {
  //         console.log('value0 - ', value, options)

  //         if (value === 0) {
  //           const prevValue =
  //             reactObj.t_tmpPrevStatus != null ? reactObj.t_tmpPrevStatus : values.status
  //           const { t } = reactObj.props
  //           Modal.confirm({
  //             title: 'Confirm',
  //             icon: <ExclamationCircleOutlined />,
  //             content: t('workspace.confirm.close'),
  //             okText: 'Ok',
  //             cancelText: 'Cancel',
  //             maskTransitionName: 'maskTransitionName',
  //             onOk() {
  //               console.log('Ok')
  //             },
  //             onCancel() {
  //               console.log('Cancel')
  //               reactObj.editObj.setFields({ status: prevValue })
  //               reactObj.t_tmpPrevStatus = prevValue
  //             },
  //           })
  //         }
  //         reactObj.t_tmpPrevStatus = value
  //       },
  //     }
  //   },
  // }),
  custom_owner: Ngql.Field(false, null, {
    mode: 'readonly',
    labelKey: i18Key('workspace.field.owner'),
    type: 'custom',
    createDetailElem: (info, reactObj, val, NineGQLUI, values) => {
      // console.log('custom - ', info, reactObj, val, NineGQLUI, values)
      if (values != null && values.userWorkspaces != null) {
        const { edges } = values.userWorkspaces
        const owners = edges
          .filter(({ node }) => {
            return node.type === 'owner'
          })
          .map(({ node }) => {
            const { displayName, email } = node.user
            if (displayName != null && displayName.trim().length > 0) {
              return `${displayName}(${email})`
            }
            return email
          })

        let ownerStr = owners.join(', ')
        if (ownerStr.length === 0) {
          ownerStr = '-'
        }

        return <span>{ownerStr}</span>
      }
      return <span>-</span>
    },
  }),
  custom_admin: Ngql.Field(false, null, {
    mode: 'readonly',
    labelKey: i18Key('workspace.field.admin'),
    type: 'custom',
    createDetailElem: (info, reactObj, val, NineGQLUI, values) => {
      // console.log('custom - ', info, reactObj, val, NineGQLUI, values)
      if (values != null && values.userWorkspaces != null) {
        const { edges } = values.userWorkspaces
        const owners = edges
          .filter(({ node }) => {
            return node.type === 'admin'
          })
          .map(({ node }) => {
            const { displayName, email } = node.user
            if (displayName != null && displayName.trim().length > 0) {
              return `${displayName} (${email})`
            }
            return email
          })

        return <span>{owners.join(', ')}</span>
      }
      return <span>-</span>
    },
  }),
  // custom_file_count: Ngql.Field(false, null, {
  //   mode: 'readonly',
  //   labelKey: i18Key('workspace.field.totalFileCount'),
  //   type: 'custom',
  //   createDetailElem: (info, reactObj /* , val, NineGQLUI, values */) => {
  //     // console.log('custom - ', info, reactObj, val, NineGQLUI, values)
  //     if (reactObj != null && reactObj.etcData != null) {
  //       return <span><NumericFormat value={reactObj.etcData.total_count} displayType="text" thousandSeparator /></span>
  //     }
  //     return <span>-</span>
  //   },
  // }),
  // custom_total_size: Ngql.Field(false, null, {
  //   mode: 'readonly',
  //   labelKey: i18Key('workspace.field.totalFileSize'),
  //   type: 'custom',
  //   createDetailElem: (info, reactObj /* , val, NineGQLUI, values */) => {
  //     // console.log('custom - ', info, reactObj, val, NineGQLUI, values)
  //     if (reactObj != null && reactObj.etcData != null) {
  //       // return <span><NumericFormat value={reactObj.etcData.total_size} displayType="text" suffix=" bytes" thousandSeparator /></span>
  //       return <span>{filesize(reactObj.etcData.total_size, {base: 2, standard: "jedec"})}</span>
  //     }
  //     return <span>-</span>
  //   },
  // }),
  // expiredAt: Ngql.Field(true, null, {
  //   // mode: 'all',
  //   modeFunc: () => {
  //     const { expiredAtEditable } = getConfig('workspace')
  //     if (expiredAtEditable === true) {
  //       return 'all'
  //     }
  //     return 'read'
  //   },
  //   labelKey: i18Key('workspace.field.expiredAt'),
  //   type: 'datetime',
  // }),
  createdAt: Ngql.Field(true, null, {
    mode: 'read',
    labelKey: i18Key('workspace.field.createdAt'),
    // type: 'datetime',
    type: 'custom',
    createDetailElem: (info, reactObj, val, NineGQLUI, values) => {
      if (values != null && values.createdAt != null) {
        return <span>{timeFormat(values.createdAt, 'lll')}</span>
      }
      return <span>-</span>
    },
  }),
  updatedAt: Ngql.Field(true, null, {
    mode: 'read',
    labelKey: i18Key('workspace.field.updatedAt'),
    // type: 'datetime',
    type: 'custom',
    createDetailElem: (info, reactObj, val, NineGQLUI, values) => {
      if (values != null && values.createdAt != null) {
        return <span>{timeFormat(values.updatedAt, 'lll')}</span>
      }
      return <span>-</span>
    },
  }),
  // userWorkspaces: Ngql.NodeConnection(null, {
  //   userWorkspaceFilter: Ngql.Var('filters', 'UserWorkspaceFilter'),
  // }),
  workspaceAppconfigs: Ngql.NodeConnection(null, {}),
  workspaceAllowedDomains: Ngql.NodeConnection(Ngql.Node(workspaceAllowedDomainField), {
    // allowedDomainFilter: Ngql.Var('filter', 'WorkspaceAllowedDomainFilter'),
    allowedDomainSort: Ngql.Var('sort', '[WorkspaceAllowedDomainNodeSortEnum]'),
  }),
}

const WorkspaceNode = Ngql.Node(WorkspaceNodeField)

const queryWorkspaceList = Ngql.Query('workspaceList', {
  allWorkspaces: Ngql.NodeConnection(WorkspaceNode, {
    sort: Ngql.Var('sort', '[WorkspaceNodeSortEnum]'),
    pageNum: Ngql.Var('pageNum', 'Int'),
    pageSize: Ngql.Var('pageSize', 'Int'),
    filters: Ngql.Var('filters', 'WorkspaceFilter'),
  }),
})

const orgChartPropertyField = {
  active: Ngql.Field(true, null, {
    mode: 'all',
    labelKey: i18Key('workspace.orgChart.active'),
    // type: 'checkbox',
    type: 'hidden',
    config: {
      rules: [{ required: true }],
    },
  }),
  upload: Ngql.Field(false, null, {
    mode: 'write',
    labelKey: i18Key('workspace.orgChart.newCredential'),
    type: 'custom',
    createEditElem: (info, reactObj, val, NineGQLUI, values) => {
      console.log(info, reactObj, val, NineGQLUI, values)
      const { t } = reactObj.props
      const { attrs } = NineGQLUI.getAttrs(info)

      const selectedFileName = reactObj.selectedFile ? (
        <React.Fragment>{reactObj.selectedFile.name}&nbsp;&nbsp;</React.Fragment>
      ) : (
        ''
      )
      return (
        <Form.Item label={info.editLabel} key={info.name} {...attrs}>
          <div className="uploadElem">
            {selectedFileName}
            <Button
              type="primary"
              className="mr-2"
              key="refresh"
              onClick={() => {
                reactObj.openCredential()
              }}
            >
              {t('workspace.button.newCredential')}
            </Button>
          </div>
        </Form.Item>
      )
    },
  }),
  credentialFilename: Ngql.Field(true, null, {
    mode: 'read',
    labelKey: i18Key('workspace.orgChart.credentialFilename'),
    type: 'text',
  }),
  syncUpdated: Ngql.Field(true, null, {
    mode: 'read',
    labelKey: i18Key('workspace.orgChart.syncUpdated'),
    type: 'datetime',
  }),
}

const queryGetOrgChartPropertyInfo = Ngql.Query('getOrgChartPropertyInfo', {
  getOrgChartPropertyInfo: Ngql.Node(orgChartPropertyField, null, false, {
    workspaceId: Ngql.Var('workspaceId', 'Int!'),
  }),
})

// const userWorkspaceNodeField = {
//   id: true,
//   nid: true,
//   userId: true,
//   workspaceId: true,
//   type: true,
//   active: true,
//   createdAt: true,
//   updatedAt: true,
//   user: Ngql.Node(UserNodeField),
//   // workspace: Ngql.Node(workspaceNodeField),
// }

// const userWorkspaceNode = Ngql.Node(userWorkspaceNodeField)

// const queryUserWorkspaceList = Ngql.Query('userWorkspaceList', {
//   allUserworkspaces: Ngql.NodeConnection(userWorkspaceNode, {
//     sort: Ngql.Var('sort', '[UserWorkspaceNodeSortEnum]'),
//     pageNum: Ngql.Var('pageNum', 'Int'),
//     pageSize: Ngql.Var('pageSize', 'Int'),
//     filters: Ngql.Var('filters', 'UserWorkspaceFilter'),
//   }),
// })

const userAccesstimeNodeField = {
  // id: true,
  userGid: true,
  email: true,
  type: true,
  active: true,
  accessTime: true,
  userCreatedAt: true,
  // userUpdatedAt: true,
}

const userAccesstimeNode = Ngql.Node(userAccesstimeNodeField)

const queryUserAccesstimeList = Ngql.Query('userAccesstimeList', {
  allUserAccesstimes: Ngql.NodeConnection(userAccesstimeNode, {
    sort: Ngql.Var('sort', '[UserAccesstimeNodeSortEnum]'),
    pageNum: Ngql.Var('pageNum', 'Int'),
    pageSize: Ngql.Var('pageSize', 'Int'),
    filters: Ngql.Var('filters', 'UserAccesstimeFilter'),
  }),
})

const WorkspaceDetailNodeField = {
  ...WorkspaceNodeField,
  allowedDomain: Ngql.Field(false, null, {
    mode: 'all',
    labelKey: i18Key('workspace.field.allowedDomain'),
    type: 'hidden', // 'custom',
    createEditElem: customAllowedDomain.createEditElem,
    createDetailElem: customAllowedDomain.createDetailElem,
  }),
  userWorkspaces: Ngql.NodeConnection(
    Ngql.Node({
      id: true,
      type: true,
      active: true,
      user: UserNode,
    }),
    {
      userTypefilters: Ngql.Var('filters', 'UserWorkspaceFilter'),
    },
  ),
  workspaceAppconfigs: Ngql.NodeConnection(
    Ngql.Node({
      id: true,
      active: true,
      appconfig: AppConfigNode,
    }),
  ),
  // serverType이 'REWORK-ONLINE'인 경우에만 표시.
  // workspacePayments: Ngql.NodeConnection(Ngql.Node(paymentQuery.workspacePaymentsNodeField), {}),
  // workspacePayment: Ngql.Node(workspacePaymentsNodeField),
}

const WorkspaceDetailNodeFieldForAppconfig = {
  id: true,
  workspaceAppconfigs: Ngql.NodeConnection(
    Ngql.Node({
      id: true,
      active: true,
      appconfig: AppConfigNode,
    }),
  ),
}

const { paymentInfoEnable } = getConfig('workspace')

if (paymentInfoEnable === true) {
  const workspacePaymentsNodeField = {
    id: true,
    nid: true,
    workspaceId: true,
    detail: Ngql.Field(false, null, {
      mode: 'read',
      labelKey: ' ',
      type: 'custom',
      createEditElem: () => {
        return '-'
      },
      createDetailElem: (compInfo, reactObj, val, NineGQLUI, values) => {
        if (values != null) {
          return (
            <Link to={`/payment/detail/${values.id}`}>
              {reactObj.props.t('workspace.desc.movePaymentDetail')}
            </Link>
          )
        }
        return '-'
      },
    }),
    type: Ngql.Field(true, null, {
      mode: 'read',
      labelKey: i18Key('payment.field.type'),
      type: 'text',
    }),
    email: Ngql.Field(true, null, {
      mode: 'read',
      labelKey: i18Key('payment.field.email'),
      type: 'text',
    }),
    planName: Ngql.Field(true, null, {
      mode: 'read',
      labelKey: i18Key('payment.field.planName'),
      type: 'text',
    }),
    paymentMethod: Ngql.Field(true, null, {
      mode: 'read',
      labelKey: i18Key('payment.field.paymentMethod'),
      type: 'text',
    }),
    status: Ngql.Field(true, null, {
      mode: 'read',
      labelKey: i18Key('payment.field.status'),
      type: 'text',
    }),
    nextBillDate: Ngql.Field(true, null, {
      mode: 'read',
      labelKey: i18Key('payment.field.nextBillDate'),
      type: 'datetime',
    }),
  }

  WorkspaceDetailNodeField.workspacePayment = Ngql.Node(workspacePaymentsNodeField)
}

const WorkspaceDetailNode = Ngql.Node(WorkspaceDetailNodeField)

const queryWorkspaceInfo = Ngql.Query('workspaceInfo', {
  allWorkspaces: Ngql.NodeConnection(WorkspaceNode, {
    filters: Ngql.Var('filters', 'WorkspaceFilter'),
  }),
})

const queryUseAddMembersInWorkspace = Ngql.Query('useAddMembersInWorkspace', {
  useAddMembersInWorkspace: true,
})

const queryWorkspaceDetailInfo = Ngql.Query('workspaceInfo', {
  allWorkspaces: Ngql.NodeConnection(WorkspaceDetailNode, {
    filters: Ngql.Var('filters', 'WorkspaceFilter'),
  }),
})

const WorkspaceDetailNodeForAppconfig = Ngql.Node(WorkspaceDetailNodeFieldForAppconfig)

const queryWorkspaceDetailInfoForAppconfig = Ngql.Query('workspaceInfo', {
  allWorkspaces: Ngql.NodeConnection(WorkspaceDetailNodeForAppconfig, {
    filters: Ngql.Var('filters', 'WorkspaceFilter'),
  }),
})

const mutationCreateWorkspace = Ngql.Mutation('createWorkspace', {
  createWorkspace: Ngql.Node(
    {
      workspace: Ngql.renamed('workspace', WorkspaceNode),
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      workspaceData: Ngql.Var('workspaceData', 'WorkspaceInput!'),
    },
  ),
})

const mutationUpdateWorkspace = Ngql.Mutation('updateWorkspace', {
  updateWorkspace: Ngql.Node(
    {
      workspace: Ngql.renamed('workspace', WorkspaceNode),
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      workspaceData: Ngql.Var('workspaceData', 'WorkspaceInput'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const mutationSelectAppconfig = Ngql.Mutation('selectAppconfig', {
  selectAppconfig: Ngql.Node(
    {
      result: true,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      appconfigGid: Ngql.Var('appconfigGid', 'String'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const workspaceNodeArray = Ngql.Node(WorkspaceNodeField, null, false, null, true)

const mutationDeleteWorkspace = Ngql.Mutation('deleteWorkspace', {
  deleteWorkspace: Ngql.Node(
    {
      results: workspaceNodeArray,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      workspaceGids: Ngql.Var('workspaceGids', '[String!]'),
    },
  ),
})

// const userWorkspaceNodeField2 = {
//   id: true,
//   user: UserNode,
//   workspace: WorkspaceNode,
//   type: true,
//   updatedAt: true,
//   createdAt: true,
// }

// const userWorkspaceNodeArray = Ngql.Node(userWorkspaceNodeField2, null, false, null, true)

const mutationUnlinkUser = Ngql.Mutation('unlinkUserworkspace', {
  unlinkUserworkspace: Ngql.Node(
    {
      // results: userWorkspaceNodeArray,
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      userGids: Ngql.Var('userGids', '[String!]'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const mutationCreateAllowedDomain = Ngql.Mutation('CreateAllowedDomain', {
  createWorkspaceAllowedDomain: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      // allowedDomain: Ngql.Var('allowedDomain', 'String!'),
      // workspaceGid: Ngql.Var('workspaceGid', 'String!'),
      domain: Ngql.Var('domain', 'String!'),
    },
  ),
})

const mutationUpdateAllowedDomain = Ngql.Mutation('updateAllowedDomain', {
  updateWorkspaceAllowedDomain: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      allowedDomain: Ngql.Var('allowedDomain', 'String!'),
      allowedDomainGid: Ngql.Var('workspaceAllowedDomainGid', 'String!'),
    },
  ),
})

const mutationDeleteAllowedDomain = Ngql.Mutation('deleteAllowedDomain', {
  deleteWorkspaceAllowedDomain: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      domain: Ngql.Var('domain', 'String!'),
      // allowedDomainGidList: Ngql.Var('workspaceAllowedDomainGidList', '[String!]'),
    },
  ),
})

const mutationCreateGoogleOrgChart = Ngql.Mutation('createGoogleOrgChart', {
  createGoogleOrgChart: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      file: Ngql.Var('file', 'Upload!'),
      googleOrgChartInfo: Ngql.Var('googleOrgChartInfo', 'GoogleOrgChartInfoInput!'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const mutationUpdateGoogleOrgChart = Ngql.Mutation('updateGoogleOrgChart', {
  updateGoogleOrgChart: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      file: Ngql.Var('file', 'Upload'),
      googleOrgChartInfo: Ngql.Var('googleOrgChartInfo', 'GoogleOrgChartInfoInput'),
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const mutationRefreshOrgChart = Ngql.Mutation('refreshOrgChart', {
  refreshOrgChart: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const mutationRemoveCredentialGoogleOrgChart = Ngql.Mutation('removeCredentialGoogleOrgChart', {
  removeCredentialGoogleOrgChart: Ngql.Node(
    {
      ok: true,
      errors: true,
    },
    null,
    false,
    {
      workspaceGid: Ngql.Var('workspaceGid', 'String!'),
    },
  ),
})

const workspaceQueries = {
  // billingInfoNodeField,
  WorkspaceNodeField,
  WorkspaceNode,
  queryWorkspaceList,
  queryWorkspaceInfo,
  queryUseAddMembersInWorkspace,
  queryGetOrgChartPropertyInfo,
  // queryUserWorkspaceList,
  queryUserAccesstimeList,
  queryWorkspaceDetailInfo,
  queryWorkspaceDetailInfoForAppconfig,
  mutationCreateWorkspace,
  mutationUpdateWorkspace,
  mutationSelectAppconfig,
  mutationDeleteWorkspace,
  mutationUnlinkUser,
  mutationCreateAllowedDomain,
  mutationUpdateAllowedDomain,
  mutationDeleteAllowedDomain,
  mutationCreateGoogleOrgChart,
  mutationUpdateGoogleOrgChart,
  mutationRefreshOrgChart,
  mutationRemoveCredentialGoogleOrgChart,
}

export default workspaceQueries
